import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { VendorDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getById = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto>({
      method: 'GET',
      url: `/api/app/vendor/${id}/by-id`,
    },
    { apiName: this.apiName,...config });
}